import { differenceInCalendarDays } from 'date-fns';

export interface DefaultInterval {
  start: Date;
  end: Date;
}

/**
 * Default do "Período de Análise" do Comparador Clássico ao abrir (#1822, item 5.3).
 *
 * Regra da Bruna (reunião 15/07): período do **D+1 até o 15º dia**. Aqui isso é
 * feito COM CLAMP à disponibilidade, pra nunca abrir a tela vazia:
 *   início = 1ª data disponível com diff ≥ D+1
 *   fim    = última data disponível com diff ≤ D+15
 * Se toda a janela cai fora de [D+1, D+15], colapsa na data disponível mais
 * próxima (última, se tudo no passado; primeira, se tudo além de D+15).
 */
export function clampedDefaultInterval(
  possibleIntervals: Date[],
  today: Date,
): DefaultInterval | undefined {
  if (possibleIntervals.length === 0) return undefined;

  const sorted = [...possibleIntervals].sort((a, b) => a.getTime() - b.getTime());
  const diff = (date: Date) => differenceInCalendarDays(date, today);

  const start = sorted.find((date) => diff(date) >= 1) ?? sorted[sorted.length - 1];
  const end = [...sorted].reverse().find((date) => diff(date) <= 15) ?? sorted[0];

  // Se o clamp cruzou (start depois de end), colapsa num único dia válido.
  if (start.getTime() > end.getTime()) {
    return { start: end, end };
  }

  return { start, end };
}
